import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const TestsHiringProcess: React.FC = () => {
  const { locale } = useRouter();

  const GRAPH_04_TESTS_IN_A_HIRING_PROCESS = [
    { label: '1', value: 1 },
    { label: '2', value: 5 },
    { label: '3', value: 22 },
    { label: '4', value: 15 },
    { label: '5', value: 10 },
    { label: '6', value: 4 }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer width="99%" height={300}>
          <BarChart
            data={GRAPH_04_TESTS_IN_A_HIRING_PROCESS}
            margin={{ left: 30, bottom: 20 }}
          >
            <XAxis
              type="category"
              allowDecimals={false}
              dataKey="label"
              tickLine={false}
              label={{
                value:
                  locale === 'es' ? 'Número de pruebas' : 'Number of tests',
                offset: 0,
                position: 'bottom'
              }}
            />
            <YAxis
              type="number"
              tickLine={false}
              width={30}
              label={{
                value: locale === 'es' ? 'Frecuencia' : 'Frequency',
                angle: -90,
                offset: -10,
                position: 'insideLeft'
              }}
            />
            <Tooltip
              cursor={{ fill: '#e6fcff' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value, '']}
              wrapperClassName="tooltip-x"
            />
            <Bar dataKey="value" fill="#8DC3D7" barSize={74} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default TestsHiringProcess;
